module.exports = __webpack_public_path__ + "img/keycap-number-sign.7f0fd1ee.png";